import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (lenis) return lenis;
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) return null;
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  return lenis;
}

export function scrollToId(selector) {
  const el = document.querySelector(selector);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -88, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

// Pause/resume page scrolling while an overlay (e.g. the Razorpay payment
// modal) owns the screen — keeps the fixed iframe steady on mobile touch.
export function pauseScroll() {
  if (lenis) lenis.stop();
}

export function resumeScroll() {
  if (lenis) lenis.start();
}

// --- Tidio live chat: scroll isolation ---
// Tidio renders in a cross-origin iframe, so while its chat is open we freeze the
// page scroll; drags inside the chat can never scroll the page underneath.
export function initTidioScrollIsolation() {
  if (typeof window === "undefined") return;
  let attempts = 0;
  const timer = setInterval(() => {
    const api = window.tidioChatApi;
    if (api && typeof api.on === "function") {
      clearInterval(timer);
      const lock = () => {
        document.documentElement.classList.add("tidio-scroll-lock");
        pauseScroll();
      };
      const unlock = () => {
        document.documentElement.classList.remove("tidio-scroll-lock");
        resumeScroll();
      };
      api.on("open", lock);
      api.on("close", unlock);
    } else if (++attempts > 60) {
      // Tidio blocked or not configured — stop polling, never loop forever.
      clearInterval(timer);
    }
  }, 500);
}
